export default function convertSetToString<T>(set: Set<T>): string {
    const result = new Array<T>();
    for (let e of set) {
        result.push(e);
    }
    return JSON.stringify(result);
}
